import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgValetParking = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="#4F5052"
        d="m15.5 21-.5-6-1.5-1v-4q0-.825.588-1.412A1.93 1.93 0 0 1 15.5 8h.5l1 2 1-2h.5q.824 0 1.413.588.587.587.587 1.412v4L19 15l-.5 6zM17 7q-.825 0-1.412-.588A1.93 1.93 0 0 1 15 5h4q0 .824-.587 1.412A1.93 1.93 0 0 1 17 7m-2-3V3q0-.424.287-.712A.97.97 0 0 1 16 2h2q.424 0 .712.288Q19 2.575 19 3v1zM8 21a.97.97 0 0 1-.713-.288A.97.97 0 0 1 7 20v-1H2v-2h6v-5H2v-2h5.2L6.15 7H2V5h4.5q.475 0 .862.275.388.275.538.725l2.1 6v8q0 .424-.287.712A.97.97 0 0 1 9 21zm-2.5-5q.624 0 1.063-.437Q7 15.125 7 14.5t-.437-1.062A1.45 1.45 0 0 0 5.5 13q-.625 0-1.062.438A1.45 1.45 0 0 0 4 14.5q0 .624.438 1.063Q4.874 16 5.5 16"
      />
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgValetParking);
export default Memo;
